export const authRoutes = {
  login: "/login",
  signup: "/cadastro",
  forgotPassword: "/esqueci-senha",
  resetPassword: "/reset-senha",
  verifyEmail: "/verificar-email",
  completeSignup: "/finalizar-cadastro",
  selectAccount: "/selecionar-conta",
  supportAccess: "/support-login",
  dashboard: "/painel",
};

export const METHOD_LOGIN_KEY = "METHOD_LOGIN";
